import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import {
  ISupplier, ISupplierCreatePayload, ISupplierUpdatePayload,
  IPartCategory, IPartCategoryCreatePayload, IPartCategoryUpdatePayload,
  IPart, IPartCreatePayload, IPartUpdatePayload,
  IStockLocation, IStockLocationCreatePayload, IStockLocationUpdatePayload,
  IStockLevel,
  IStockMovement, IStockMovementCreatePayload,
} from "../../../types/api/inventory";

// Suppliers
export async function listSuppliers(params: any): Promise<AxiosResponse<TResponseWithQData<ISupplier[]>>> {
  return axios.get(API_ENDPOINTS.SUPPLIER_LIST, { params });
}
export async function createSupplier(data: ISupplierCreatePayload): Promise<AxiosResponse<TResponse<ISupplier>>> {
  return axios.post<TResponse<ISupplier>>(API_ENDPOINTS.SUPPLIER_CREATE, data);
}
export async function updateSupplier(data: ISupplierUpdatePayload): Promise<AxiosResponse<TResponse<ISupplier>>> {
  return axios.post<TResponse<ISupplier>>(API_ENDPOINTS.SUPPLIER_UPDATE, data);
}
export async function deleteSupplier(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.SUPPLIER_DELETE, { id });
}

// Part Categories
export async function listPartCategories(params: any): Promise<AxiosResponse<TResponse<IPartCategory[]>>> {
  return axios.get(API_ENDPOINTS.PART_CATEGORY_LIST, { params });
}
export async function createPartCategory(data: IPartCategoryCreatePayload): Promise<AxiosResponse<TResponse<IPartCategory>>> {
  return axios.post<TResponse<IPartCategory>>(API_ENDPOINTS.PART_CATEGORY_CREATE, data);
}
export async function updatePartCategory(data: IPartCategoryUpdatePayload): Promise<AxiosResponse<TResponse<IPartCategory>>> {
  return axios.post<TResponse<IPartCategory>>(API_ENDPOINTS.PART_CATEGORY_UPDATE, data);
}
export async function deletePartCategory(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.PART_CATEGORY_DELETE, { id });
}

// Parts
export async function listParts(params: any): Promise<AxiosResponse<TResponseWithQData<IPart[]>>> {
  return axios.get(API_ENDPOINTS.PART_LIST, { params });
}
export async function partDetail(id: number): Promise<AxiosResponse<TResponse<IPart>>> {
  return axios.get(`${API_ENDPOINTS.PART_DETAIL}/${id}`);
}
export async function createPart(data: IPartCreatePayload): Promise<AxiosResponse<TResponse<IPart>>> {
  return axios.post<TResponse<IPart>>(API_ENDPOINTS.PART_CREATE, data);
}
export async function updatePart(data: IPartUpdatePayload): Promise<AxiosResponse<TResponse<IPart>>> {
  return axios.post<TResponse<IPart>>(API_ENDPOINTS.PART_UPDATE, data);
}
export async function deletePart(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.PART_DELETE, { id });
}

// Stock Locations
export async function listStockLocations(params: any): Promise<AxiosResponse<TResponse<IStockLocation[]>>> {
  return axios.get(API_ENDPOINTS.STOCK_LOCATION_LIST, { params });
}
export async function createStockLocation(data: IStockLocationCreatePayload): Promise<AxiosResponse<TResponse<IStockLocation>>> {
  return axios.post<TResponse<IStockLocation>>(API_ENDPOINTS.STOCK_LOCATION_CREATE, data);
}
export async function updateStockLocation(data: IStockLocationUpdatePayload): Promise<AxiosResponse<TResponse<IStockLocation>>> {
  return axios.post<TResponse<IStockLocation>>(API_ENDPOINTS.STOCK_LOCATION_UPDATE, data);
}
export async function deleteStockLocation(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.STOCK_LOCATION_DELETE, { id });
}

// Stock Levels
export async function listStockLevels(params: any): Promise<AxiosResponse<TResponse<IStockLevel[]>>> {
  return axios.get(API_ENDPOINTS.STOCK_LEVEL_LIST, { params });
}

// Stock Movements
export async function listStockMovements(params: any): Promise<AxiosResponse<TResponseWithQData<IStockMovement[]>>> {
  return axios.get(API_ENDPOINTS.STOCK_MOVEMENT_LIST, { params });
}
export async function createStockMovement(data: IStockMovementCreatePayload): Promise<AxiosResponse<TResponse<IStockMovement>>> {
  return axios.post<TResponse<IStockMovement>>(API_ENDPOINTS.STOCK_MOVEMENT_CREATE, data);
}
